/************定义canvas图层************/
function WindOverLayer(map,windData,colorScale) {
  this._map = map
  this._windData = windData
  this._colorScale=colorScale
}

// var rectPoints = [109.600899, 25.593504, 117.401353, 20.175226]; //左上、右下经纬度

WindOverLayer.prototype = new BMap.Overlay();

WindOverLayer.prototype.initialize = function () {
    var map = this._map
    var windData = this._windData
    var canvas = document.createElement('canvas');
    canvas.id = "windCanvas";
    canvas.width = map.getSize().width;
    canvas.height = map.getSize().height;
    canvas.style.position = 'absolute';
    canvas.style.top = 0; 
    canvas.style.left = 0;
    map.getPanes().labelPane.appendChild(canvas);
    
    this._canvas = canvas;
    this._windy = new Windy({
        map: map,
        canvas: canvas,
        data: windData,
        colorScale: this._colorScale
    });
};

WindOverLayer.prototype.draw = function () {
    var canvas = this._canvas;
    var windy = this._windy;
    var map = this._map
    var windData = this._windData
    var bounds = this._map.getBounds(); //返回当前视口的西南纬度/经度和东北纬度/经度
    var sw = bounds.getSouthWest();
    var ne = bounds.getNorthEast();
    var py = this._map.pointToOverlayPixel(new BMap.Point(sw.lng, ne.lat)); //经纬度转成屏幕坐标
    canvas.style.left = py.x + 'px';
    canvas.style.top = py.y + 'px';
    var points = this.invertLatLon(py); //所有站点经纬度转为canvas坐标
    // var min = map.pointToOverlayPixel(new BMap.Point(rectPoints[0], rectPoints[1]));
    // var max = map.pointToOverlayPixel(new BMap.Point(rectPoints[2], rectPoints[3]));
    var min = this._map.pointToOverlayPixel(new BMap.Point(sw.lng, ne.lat));
    var max = this._map.pointToOverlayPixel(new BMap.Point(ne.lng, sw.lat));

    windy.start([
        [min.x - py.x, min.y - py.y],
        [max.x - py.x, max.y - py.y]
    ], points);
}

WindOverLayer.prototype.invertLatLon = function (py) {
    var map = this._map
    var windData = this._windData
    var points = [];
    windData.forEach(function (station) {
        var px = map.pointToOverlayPixel(new BMap.Point(station[1], station[0]));
        points.push({
            x: px.x - py.x,
            y: px.y - py.y,
            angle: station[2],
            speed: station[3]
        });
    });
    return points;
}

WindOverLayer.prototype.hide = function(){
    this._canvas.style.display = 'none'
}

WindOverLayer.prototype.clear = function(){
    // console.log(this._windy)
    // this._canvas.style.display = 'none'
    if (this._canvas && this._canvas.parentNode){
        this._canvas.parentNode.removeChild(this._canvas)
        let context = this._canvas.getContext('2d')
        context.beginPath();
        context.clearRect(0,0,this._canvas.width,this._canvas.height);    
    }
    
}
export {WindOverLayer}


// WEBPACK FOOTER //
// ./src/utils/wind_map.js